export const hasModifier = (needle: string, modifiers: Record<string, boolean>): boolean => {
  return Object.entries(modifiers).some(([key, value]) => {
    return typeof key === 'string' && key.startsWith(needle) && value
  })
}
